import React, { useEffect, useState } from 'react';
import CommonLayout from "../../layouts/CommonLayout";
import useAuthStore from '../../../store/authStore';
import { getRiceTransactions } from '../../../api/RiceTransactionApi';
import { useNavigate } from 'react-router-dom';

const RiceWalletPage = () => {
    const { member } = useAuthStore();
    const navigate = useNavigate();
    const [transactions, setTransactions] = useState([]);
    const [nextCursor, setNextCursor] = useState(null);
    const [hasNext, setHasNext] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const loadTransactions = async (cursor = null) => {
        if (isLoading) return;
        try {
            setIsLoading(true);
            const data = await getRiceTransactions(cursor);
            // 첫 로드 또는 더보기 로드
            setTransactions(prev => cursor ? [...prev, ...data.riceTransactionDtoList] : data.riceTransactionDtoList);
            setNextCursor(data.nextCursor);
            setHasNext(data.hasNext);
        } catch (e) {
            console.error('쌀 트랜잭션 조회 실패:', e);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadTransactions(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getRiceTransactionReason = (reason) => {
        switch (reason) {
            case 'SIGNUP':
                return '최초 가입';
            case 'MEETING_APPLY':
                return '모임 신청';
            case 'MEETING_APPLY_REJECT':
                return '모임 신청 거절';
            case 'MEETING_APPLY_DELETE':
                return '모임 신청 삭제';
            case 'MEETING_CREATE':
                return '모임 만들기';
            case 'MEETING_JOIN':
                return '모임 참여';
            case 'MEETING_CHECKED':
                return '모임 출석체크';
            case 'MEETING_DELETE':
                return '모임 삭제';
            case 'MEETING_END':
                return '모임 최소인원 미충족 종료';
            case 'MEETING_LEAVE':
                return '모임 나가기';
            case 'PURCHASE_500':
                return '쌀 500개 구입';
            case 'PURCHASE_1000':
                return '쌀 1000개 구입';
            case 'PURCHASE_2000':
                return '쌀 2000개 구입';
            case 'ADMIN_GRANT':
                return '관리자 지급';
            case 'ADMIN_REVOKE':
                return '관리자 회수';
            default:
                return '기타';
        }
    }

    return (
        <CommonLayout title="쌀 지갑">
            <div className="p-4">
                {/* 현재 잔액 */}
                <div className="bg-white rounded-lg border border-gray-200 p-4 mb-3">
                    <div className="flex items-center">
                        <img src="/images/rice_1.png" alt="쌀" className="w-12 h-12 mr-3" />
                        <div>
                            <h3 className="text-md text-gray-500 mb-1">현재 잔액</h3>
                            <p className="text-2xl font-semibold">{(member?.riceBalance ?? 0).toLocaleString()} 알</p>
                        </div>
                    </div>
                </div>

                {/* 쌀 충전 버튼 */}
                <button className="w-full bg-amber-500 text-white py-3 rounded-lg font-medium mb-4 active:bg-amber-600 transition-colors"
                    onClick={() => navigate('/app/mypage/rice-purchase')}
                >
                    쌀 충전
                </button>

                {/* 트랜잭션 목록 */}
                <div className="bg-white rounded-lg border border-gray-200">
                    {transactions.length === 0 ? (
                        <div className="p-4 text-center text-gray-500">내역이 없습니다</div>
                    ) : (
                        <ul className="divide-y divide-gray-100">
                            {transactions.map(tx => (
                                <li key={tx.id} className="px-4 py-3 flex items-center justify-between">
                                    <div>
                                        <div className="text-sm text-gray-500">{new Date(tx.createdAt).toLocaleString()}</div>
                                        <div className="text-sm text-gray-700">{getRiceTransactionReason(tx.riceTransactionReason)}</div>
                                    </div>
                                    <div className="text-right">
                                        <div className={`text-base font-semibold ${tx.amount >= 0 ? 'text-green-600' : 'text-amber-600'}`}>{tx.amount >= 0 ? `+${tx.amount}` : tx.amount} 알</div>
                                        <div className="text-xs text-gray-500">잔액 {tx.balanceAfter} 알</div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}

                    {/* 더보기 버튼 */}
                    {hasNext && (
                        <div className="px-4 py-3 border-t border-gray-100">
                            <button
                                onClick={() => loadTransactions(nextCursor)}
                                disabled={isLoading}
                                className="w-full px-4 py-2 bg-gray-100 text-gray-700 rounded-lg active:bg-gray-200 disabled:opacity-50"
                            >
                                {isLoading ? '불러오는 중...' : '더보기'}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </CommonLayout>
    );
};

export default RiceWalletPage;
